import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  closeModal: {
    id: 'reviews.modal.close',
    defaultMessage: 'Zavřít',
  },
  sendReview: {
    id: 'reviews.send.review',
    defaultMessage: 'Odeslat hodnocení',
  },
  parametersReviews: {
    id: 'reviews.parametersReviews',
    defaultMessage: 'Hodnocení parametrů',
  },
  ratingTypeDesignFlakon: {
    id: 'rating.type.designFlakon',
    defaultMessage: 'vzhled flakonu',
  },
  ratingTypePersistenceScent: {
    id: 'rating.type.persistenceScent',
    defaultMessage: 'výdrž vůně',
  },
  ratingTypeIntensity: {
    id: 'rating.type.intensity',
    defaultMessage: 'intenzita',
  },
  ratingTypeOverallImpresion: {
    id: 'rating.type.overallImpresion',
    defaultMessage: 'celkový dojem',
  },
  ratingTypeSimplicityApplication: {
    id: 'rating.type.simplicityApplication',
    defaultMessage: 'jednoduchost aplikace',
  },
  ratingTypeCosmeticQuality: {
    id: 'rating.type.cosmeticQuality',
    defaultMessage: 'kosmetická kvalita',
  },
  ratingTypeTotalHappiness: {
    id: 'rating.type.totalHappiness',
    defaultMessage: 'spokojenost s výsledkem',
  },
  notRequired: {
    id: 'reviews.not.required',
    defaultMessage: 'nepovinné',
  },
  reviewsTextErrorMaxLength: {
    id: 'reviews.input.text.error.maxLength',
    defaultMessage: 'Prosím zadejte kratší text recenze',
  },
  reviewsText: {
    id: 'reviews.input.text',
    defaultMessage: 'Vaše recenze',
  },
  reviewsTextInputPlaceholder: {
    id: 'reviews.input.text.placeholder',
    defaultMessage:
      'Co se vám na produktu líbilo/nelíbilo? Konstruktivní a upřímné hodnocení pomůže ostatním zákazníkům s výběrem. ',
  },
  reviewsProductVariantLabel: {
    id: 'reviews.input.variant.label',
    defaultMessage: 'Varianta produktu',
  },
  reviewsProductVariantPlaceholder: {
    id: 'reviews.input.variant.placeholder',
    defaultMessage: 'Vyberte variantu',
  },
  reviewsTitleLabel: {
    id: 'reviews.input.title.label',
    defaultMessage: 'Nadpis recenze',
  },
  reviewsTitleInputPlaceholder: {
    id: 'reviews.input.title.placeholder',
    defaultMessage: 'Skvělý produkt!',
  },
  reviewsTextErrorRequired: {
    id: 'reviews.input.text.error.required',
    defaultMessage: 'Prosím zadejte vaši recenzi',
  },
  reviewsName: {
    id: 'reviews.input.name',
    defaultMessage: 'Jméno',
  },
  reviewsNamePlaceholder: {
    id: 'reviews.input.name.placeholder',
    defaultMessage: 'Přezdívka',
  },
  reviewsNameErrorRequired: {
    id: 'reviews.input.name.error.required',
    defaultMessage: 'Prosím zadejte jméno',
  },
  reviewsNameErrorMaxLength: {
    id: 'reviews.input.name.error.maxLength',
    defaultMessage: 'Prosím zadejte kratší jméno',
  },
  reviewsGDPRinfo: {
    id: 'reviews.gdpr.info',
    defaultMessage:
      'Odesláním souhlasíte se zpracováním emailu za účelem hodnocení tohoto zboží společností Notino s.r.o., se sídlem v Brně, Londýnské náměstí 881/6, PSČ 639 00, IČO 27609057 do odeslání emailu, maximálně 1 roku. Údaje mohou být předány a zpracovány sesterskými společnostmi. Máte právo svůj souhlas kdykoliv odvolat, požadovat od správce přístup k osobním údajům, jejich opravu, výmaz, přenositelnost, popřípadě omezení zpracování. Více informací v {link}.​',
  },
  reviewLogInNote: {
    id: 'reviews.login.note',
    defaultMessage:
      'Abychom mohli recenzi ověřit a byla pro ostatní zákazníky opravdu užitečná, <a>přihlaste se</a> nejprve prosím do svého účtu.',
  },
  reviewLogInNoteDrawerTitle: {
    id: 'reviews.login.note.drawer.title',
    defaultMessage: 'Přihlaste se do svého účtu',
  },
  reviewModalTitle: {
    id: 'reviews.modal.title',
    defaultMessage: 'Hodnocení produktu',
  },
  reviewAddPhotosLabel: {
    id: 'reviews.add.photos.label',
    defaultMessage: 'Přidat fotografie',
  },
  reviewAddPhotosRestrictions: {
    id: 'reviews.add.photos.restrictions',
    defaultMessage: 'Maximálně {maxCount} fotografií. Každá do {maxSize} MB.',
  },
  reviewAddPhotosButton: {
    id: 'reviews.add.photos.button',
    defaultMessage: 'Vybrat fotografie',
  },
  reviewPhotosErrorInvalidType: {
    id: 'reviews.photos.error.invalid.type',
    defaultMessage: 'Povolené jsou pouze soubory ve formátu JPEG a PNG.',
  },
  reviewPhotosErrorTooLarge: {
    id: 'reviews.photos.error.too.large',
    defaultMessage:
      'Soubor je příliš velký. Maximální velikost je {maxSize} MB.',
  },
  reviewPhotosErrorResolutionTooSmall: {
    id: 'reviews.photos.error.resolution.too.small',
    defaultMessage:
      'Rozlišení obrázku je příliš malé. Minimální rozlišení je {minWidth}×{minHeight} pixelů.',
  },
});
